import {
  Component,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  Injector,
  Output,
  EventEmitter,
} from '@angular/core';
import { DateManagerService } from '@core/services/date-manager/date-manager.service';
import { NzStatus } from 'ng-zorro-antd/core/types';

@Component({
  selector: 'xpw-input-time',
  template: `
    <nz-form-item>
      <nz-form-label>{{ label }} </nz-form-label>

      <nz-time-picker
        [(ngModel)]="value"
        nzFormat="HH:mm"
        [nzDisabled]="readonly"
        (ngModelChange)="timeChanged($event)"
        [nzStatus]="status"
        [nzAllowEmpty]="false"
        [nzDisabledHours]="disabledHours"
      ></nz-time-picker>
      <ng-content></ng-content>
    </nz-form-item>
  `,
  styles: `
    nz-time-picker {
      width: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./xpw-input-date.component.less'],
})
export class XpwInputTimeComponent {
  @Input() value: any;
  @Input() readonly: boolean = false;
  @Input('label') label: string;
  @Input('hasFeedback') hasFeedback: boolean = true;
  @Input('utcCorrection') utcCorrection: boolean = true;
  @Input() status: NzStatus = '';
  @Output() onChange = new EventEmitter<any>();

  private _specificDisabledHours: number[] = [];

  // Convert to setter to detect changes
  @Input()
  set specificDisabledHours(hours: number[]) {
    this._specificDisabledHours = hours;
    this.validateAndAdjustTime();
  }

  get specificDisabledHours(): number[] {
    return this._specificDisabledHours;
  }

  disabledHours = () => {
    return this._specificDisabledHours;
  };
  get format(): string {
    return 'HH:mm';
  }

  constructor(private dateService: DateManagerService) {
    // super(injector);
  }

  /**
   * Validates current time and adjusts to earliest available if needed
   */
  private validateAndAdjustTime(): void {
    if (!this.value || this._specificDisabledHours.length === 0) {
      return;
    }

    const currentHour = this.value.getHours();

    // Check if current hour is disabled
    if (this._specificDisabledHours.includes(currentHour)) {
      const earliestAvailableTime = this.getEarliestAvailableTime();
      if (earliestAvailableTime) {
        this.value = earliestAvailableTime;
        this.onChange.emit(this.value);
      }
    }
  }

  /**
   * Finds the earliest available time (not in disabled hours)
   */
  private getEarliestAvailableTime(): Date | null {
    const today = new Date();

    // Check each hour from 0 to 23
    for (let hour = 0; hour < 24; hour++) {
      if (!this._specificDisabledHours.includes(hour)) {
        const availableTime = new Date(today);
        availableTime.setHours(hour, 0, 0, 0); // Set to start of hour
        return availableTime;
      }
    }

    return null; // All hours are disabled (edge case)
  }

  timeChanged(value: any) {
    this.onChange.emit(value);
    // if (this.utcCorrection) {
    //   this.onChange(this.dateService.getOnlyTime(value));
    // } else {
    //   this.onChange(value);
    // }
  }

  // override writeValue(value: any): void {
  //   if (value) {
  //     super.writeValue(value);
  //   }
  // }
}
